import { GET_NETBANKING_CONFIGURATIONS, PAYMENT_USING_NETBANKING, RESET_PAYMENT_STATUS, PAYMENT_USING_PHONEPE, PHONEPE_STATUS_CHECK, GET_PAYTM_TOKEN_CALL, PAYTM_STATUS_CHECK, FETCH_OTHER_WALLETS_LIST, PAYMENT_USING_GOOGLEPAY, DELETE_SAVED_CARD, PAYMENT_FOR_ADDHOPE, GLOBALPAYMENTS_GENERATE_TOKEN, GLOBALPAYMENTS_INITIATE_PAYMENT_CALL, GLOBALPAYMENTS_VALIDATE_ADDRESSS, GLOBALPAYMENT_SAVE_CARD, PAYMENT_FOR_GIFTCARD, GLOBALPAYMENT_IS_STORE_3DS_ENABLED, GLOBALPAYMENT_VERIFY_CARD, DGFT_CREDITCARD_GENERATE_TOKEN, DGFT_APPLEPAY_GENERATE_TOKEN, DGFT_PAYMENT_AUTHORIZE_CALL, PAYMENT_REQUESTED_CALL, } from '../../constants';
export function getNetbankingConfigurations(payload) {
    return {
        type: GET_NETBANKING_CONFIGURATIONS,
        payload,
    };
}
export function payUsingNetbanking(payload) {
    return {
        type: PAYMENT_USING_NETBANKING,
        payload,
    };
}
export function resetPaymentStatus() {
    return {
        type: RESET_PAYMENT_STATUS,
    };
}
export function payUsingPhonePe(payload) {
    return {
        type: PAYMENT_USING_PHONEPE,
        payload,
    };
}
export function payUsingGooglePay(payload) {
    return {
        type: PAYMENT_USING_GOOGLEPAY,
        payload,
    };
}
export function checkPhonePeStatus(payload) {
    return {
        type: PHONEPE_STATUS_CHECK,
        payload,
    };
}
export function getPaytmToken(payload) {
    return {
        type: GET_PAYTM_TOKEN_CALL,
        payload,
    };
}
export function checkPaytmStatus(payload) {
    return {
        type: PAYTM_STATUS_CHECK,
        payload,
    };
}
export function getOtherWalletsList(payload) {
    return {
        type: FETCH_OTHER_WALLETS_LIST,
        payload,
    };
}
export function deleteSavedCard(payload, successCallback) {
    return {
        type: DELETE_SAVED_CARD,
        payload,
        successCallback,
    };
}
export function paymentForAddHope(payload) {
    return {
        type: PAYMENT_FOR_ADDHOPE,
        payload,
    };
}
export function globalPaymentsGenerateToken(payload, successCallback, errorCallback) {
    return {
        type: GLOBALPAYMENTS_GENERATE_TOKEN,
        payload,
        successCallback,
        errorCallback,
    };
}
export function globalpaymentsInitiatePayment(payload, successCallback, errorCallback) {
    return {
        type: GLOBALPAYMENTS_INITIATE_PAYMENT_CALL,
        payload,
        successCallback,
        errorCallback,
    };
}
export function globalpaymentsAddressValidate(payload, successCallback, errorCallback) {
    return {
        type: GLOBALPAYMENTS_VALIDATE_ADDRESSS,
        payload,
        successCallback,
        errorCallback,
    };
}
export function GlobalpaymentSaveCard(payload, successCallback, errorCallback) {
    return {
        type: GLOBALPAYMENT_SAVE_CARD,
        payload,
        successCallback,
        errorCallback,
    };
}
export function gpIsStore3dsEnabled(payload, successCallback, errorCallback) {
    return {
        type: GLOBALPAYMENT_IS_STORE_3DS_ENABLED,
        payload,
        successCallback,
        errorCallback,
    };
}
export function paymentForGiftCard(payload) {
    return {
        type: PAYMENT_FOR_GIFTCARD,
        payload,
    };
}
export function globalPaymentsVerifyCard(payload, successCallback, errorCallback) {
    return {
        type: GLOBALPAYMENT_VERIFY_CARD,
        payload,
        successCallback,
        errorCallback,
    };
}
export function dgftCreditCardGenerateToken(payload, successCallback, errorCallback) {
    return {
        type: DGFT_CREDITCARD_GENERATE_TOKEN,
        payload,
        successCallback,
        errorCallback,
    };
}
export function dgftApplePayGenerateToken(payload, successCallback, errorCallback) {
    return {
        type: DGFT_APPLEPAY_GENERATE_TOKEN,
        payload,
        successCallback,
        errorCallback,
    };
}
export function dgftAuthorizePayment(payload, successCallback, errorCallback) {
    return {
        type: DGFT_PAYMENT_AUTHORIZE_CALL,
        payload,
        successCallback,
        errorCallback,
    };
}
export function getPaymentRequestedData(payload, successCallback, errorCallback) {
    return {
        type: PAYMENT_REQUESTED_CALL,
        payload,
        successCallback,
        errorCallback,
    };
}
